import styles from '../../styles/motionPanel.module.scss';
import { useViewport } from '../../hooks';
import { useEffect, useRef, useState } from 'react';
import { useDrag } from '@use-gesture/react';
import { BreakpointTablet } from '../../constants/ui';
import { motion } from 'framer-motion';

const ChartsCustomNav = ({
  header,
  body,
  hideOnTablet,
  isPanelOpened = false,
  isStatic = false,
  closeTrigger,
}) => {
  const { widthViewport } = useViewport();
  const [isOpen, setIsOpen] = useState(isPanelOpened);
  const dragHandleRef = useRef(null);

  const closedOffset = 'calc(100% - 68px)';

  const toggleMenu = (open) => {
    setIsOpen(open);
  };

  useEffect(() => {
    setIsOpen(false);
  }, [closeTrigger]);

  useDrag(
    ({ movement: [, y], direction: [, dy], velocity }) => {
      if (dy < 0 && velocity > 0.3) toggleMenu(true);
      if (dy > 0 && velocity > 0.3) toggleMenu(false);
    },
    { target: dragHandleRef },
  );

  return (
    <>
      {!hideOnTablet && widthViewport > BreakpointTablet ? (
        body
      ) : (
        <motion.div
          ref={dragHandleRef}
          className={`${styles.motionPanel} ${isOpen ? styles.motionPanelActive : ''}`}
          drag="y"
          dragConstraints={{ top: 0, bottom: 0 }}
          onDragEnd={(_, info) => {
            if (info.velocity.y > 300) toggleMenu(false);
            if (info.velocity.y < -300) toggleMenu(true);
          }}
          animate={{ y: isOpen ? 0 : closedOffset }}
          transition={{ type: 'spring', stiffness: 300, damping: 40 }}
        >
          {!isStatic && <button className={styles.motionPanelTop} onClick={() => toggleMenu(!isOpen)}></button>}
          <div role={'button'} className={styles.motionPanelHeader} onClick={() => toggleMenu(!isOpen)}>
            {header}
          </div>
          <div className={styles.motionPanelBody}>{body}</div>
        </motion.div>
      )}
    </>
  );
};

export default ChartsCustomNav
